import React from 'react';
import './Post.css';
import Sidebar from './Sidebar';
import Postbar from './Postbar';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

function Post({username, profilePic, userId, about}) {
    return (
        <div className="post">
            <Sidebar 
            username={username}
            profilePic = {profilePic}
            userId = {userId}
            about = {about}
            />
            <Postbar 
            username={username}
            profilePic = {profilePic}
            userId = {userId}
            about = {about}
            />
        </div>
    )
}

export default Post
